import { gsap } from "gsap";
import { Sprite, Texture } from "pixi.js";

import { AbstractSpine } from "../../../../abstracts/graphics/AbstractSpine";
import { playSound } from "../../../../abstracts/utils/SoundUtils";
import {
    ApocalypseSoundNames,
    ApocalypseSpineNames,
} from "../../../assetsLoader/ApocalypseAssetsNames";
import { symbolConfig } from "../../../config/ApocalypseConfig";
import { ApocalypseSymbolNames, ScatterStates } from "../../../types/ApocalypseEnums";
import { ApocalypseSymbol } from "./ApocalypseSymbol";
import { returnSymbolToPool } from "./ApocalypseSymbolsPool";

export class ApocalypseScatterSymbol extends ApocalypseSymbol {
    protected currentState: ScatterStates;

    constructor() {
        super(ApocalypseSymbolNames.SCATTER);

        this.currentState = ScatterStates.NORMAL;
    }

    protected override generateSymbol() {
        this.mainSpine = new AbstractSpine(ApocalypseSpineNames.SCATTER);

        this.mainSpine.getSpineTween(`Normal`);

        this.mainSpineDefaultXPosition = symbolConfig.symbolWidth / 2;
        this.mainSpineDefaultYPosition = symbolConfig.symbolHeight / 2 - 2.5;

        this.mainTextureDefaultName = `Apocalypse/SCATTER`;

        this.mainTextureSprite = new Sprite(Texture.from(this.mainTextureDefaultName));
        this.mainTextureSprite.name = `mainTextureSprite`;
        this.mainTextureSprite.scale.set(0.5);
        this.mainTextureSprite.alpha = 1;

        this.mainTextureDefaultXPosition =
            symbolConfig.symbolWidth / 2 - this.mainTextureSprite.width / 2;
        this.mainTextureDefaultYPosition =
            symbolConfig.symbolHeight - this.mainTextureSprite.height;

        this.addChild(this.mainTextureSprite);

        this.mainSpine.x = this.mainSpineDefaultXPosition;
        this.mainSpine.y = this.mainSpineDefaultYPosition;

        this.mainTextureSprite.x = this.mainTextureDefaultXPosition;
        this.mainTextureSprite.y = this.mainTextureDefaultYPosition;
    }

    override getLandingAnimation(): gsap.core.Tween | gsap.core.Timeline {
        return gsap.to({}, {});
        // return this.mainSpine.getSpineTween(`Landing`);
    }

    public getFsTransitionAnimation(): gsap.core.Tween | gsap.core.Timeline {
        return this.mainSpine.getSpineTween(
            `fs_transition`,
            false,
            () => {
                playSound({ name: ApocalypseSoundNames.HIDE_FS_FAKE_SYMBOLS });
                this.addChild(this.mainSpine);
                this.removeChild(this.mainTextureSprite);
            },
            null,
            () => {
                returnSymbolToPool(this);
            }
        );
    }

    public override getWinAnimation(
        scatterState: ScatterStates = ScatterStates.NORMAL,
        useSecondAnimation: boolean = false
    ): gsap.core.Tween | gsap.core.Timeline {
        const initialState = this.currentState;
        this.currentState = scatterState;

        switch (scatterState) {
            case ScatterStates.WIN: {
                this.mainSpine.reset();
                this.addChild(this.mainSpine);
                this.removeChild(this.mainTextureSprite);
                this.mainSpine.state.setAnimation(0, `Win`, true);

                break;
            }

            case ScatterStates.LOSE:
                if (initialState === ScatterStates.ANTICIPATION) {
                    this.mainSpine.reset();
                    this.addChild(this.mainSpine);
                    this.removeChild(this.mainTextureSprite);
                    let animationName = `Loop_end`;
                    if (useSecondAnimation) {
                        animationName = `Loop2_end`;
                    }
                    this.mainSpine.state.setAnimation(0, animationName, false);
                } else {
                    this.addChild(this.mainTextureSprite);
                    this.removeChild(this.mainSpine);
                    this.mainSpine.state.setAnimation(0, `Normal`, false);
                }
                break;

            case ScatterStates.ANTICIPATION: {
                // if (initialState !== ScatterStates.ANTICIPATION) {
                this.mainSpine.reset();

                this.addChild(this.mainSpine);
                this.removeChild(this.mainTextureSprite);

                const tl = gsap.timeline({
                    autoRemoveChildren: true,
                    smoothChildTiming: true,
                });

                // tl.add(
                let animationName = `Loop_start`;
                if (useSecondAnimation) {
                    animationName = `Loop2_start`;
                }

                this.mainSpine.getSpineTween(
                    animationName,
                    false,
                    () => {
                        this.addChild(this.mainSpine);
                        this.removeChild(this.mainTextureSprite);
                    },
                    null,
                    () => {
                        let loopAnimationName = `Loop`;
                        if (useSecondAnimation) {
                            loopAnimationName = `Loop2`;
                        }
                        this.mainSpine.getSpineTween(loopAnimationName, true);
                    }
                );
                // );

                return tl;
                // }
                // break;
            }

            default:
                this.addChild(this.mainSpine);
                // this.removeChild(this.mainTextureSprite);
                this.mainSpine.state.setAnimation(0, `Normal`, false);

                break;
        }

        return gsap.to({}, {});
    }

    public getStopWinAnimation(): gsap.core.Tween {
        return this.mainSpine.getSpineTween(`Normal`, false, () => {
            this.addChild(this.mainTextureSprite);
            this.removeChild(this.mainSpine);
        });
    }

    override reset() {
        super.reset();
        this.currentState = ScatterStates.NORMAL;
    }

    resetOnStartSpin() {
        super.resetOnStartSpin();

        this.currentState = ScatterStates.NORMAL;
    }
}
